import { render, staticRenderFns } from "./TopicUser.vue?vue&type=template&id=01e8d4cd&scoped=true&"
import script from "./TopicUser.vue?vue&type=script&lang=js&"
export * from "./TopicUser.vue?vue&type=script&lang=js&"
import style0 from "./TopicUser.vue?vue&type=style&index=0&id=01e8d4cd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e8d4cd",
  null
  
)

export default component.exports